import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import InnsynPersonopplysningerFilterForm from "./InnsynPersonopplysningerFilterForm";

import {
    handleChange as handleChangeAction,
    handleChangeAll as handleChangeAllAction,
    handleChangeToInitState as handleChangeToInitStateAction,
} from "../../actions/handleChangeAction";
import { getInnsynByEmail as getInnsynByEmailAction } from "../../actions/personopplysningerActions";

function InnsynPersonopplysningerFilterContainer() {
  const dispatch = useDispatch();
  const innsynPersonopplysningerFilterForm = useSelector(
    (state) => state.forms.innsynPersonopplysningerFilterForm
  );

  const [showSokSpinner, setShowSokSpinner] = useState(false);

  const handleChangeAll = (payload) =>
    dispatch(
      handleChangeAllAction("INNSYN_PERSONOPPLYSNINGER_FILTER_FORM", payload)
    );

  const handleOnSubmit = (e) => {
    e.preventDefault();

    handleChangeAll({ epostValidationError: null });

    if (innsynPersonopplysningerFilterForm.epost) {
      setShowSokSpinner(true);
      dispatch(getInnsynByEmailAction(innsynPersonopplysningerFilterForm.epost))
        .then(() => setShowSokSpinner(false))
        .catch(() => setShowSokSpinner(false));
    } else {
      handleChangeAll({ epostValidationError: "E-post er påkrevd" });
    }
  };

  const handleOnChange = (e) => {
    dispatch(
      handleChangeAction(
        "INNSYN_PERSONOPPLYSNINGER_FILTER_FORM",
        e.target.name,
        e.target.value
      )
    );
  };

  const handleOnChangeToInitState = () => {
    dispatch(
      handleChangeToInitStateAction("INNSYN_PERSONOPPLYSNINGER_FILTER_FORM")
    );
  };

  return (
    <InnsynPersonopplysningerFilterForm
      showSokSpinner={showSokSpinner}
      innsynPersonopplysningerFilterForm={innsynPersonopplysningerFilterForm}
      handleOnChange={handleOnChange}
      handleOnSubmit={handleOnSubmit}
      handleOnChangeToInitState={handleOnChangeToInitState}
    />
  );
}

export default InnsynPersonopplysningerFilterContainer;
